<template>
    <div>
        <elementary-section shadow>
            <div class="container">
                <basic-form @o3-submit="onSubmit"/>
            </div>
        </elementary-section>
        <elementary-section shadow light>
            <div class="container">
                <properties-form @o3-submit="onSubmit"/>
            </div>
        </elementary-section>
        <elementary-section shadow>
            <div class="container">
                <building-form @o3-submit="onSubmit"/>
            </div>
        </elementary-section>
        <elementary-section shadow light>
            <div class="container">
                <other-form @o3-submit="onSubmit"/>
            </div>
        </elementary-section>
    </div>
</template>

<script>
import ElementarySection from '@/components/Content/ElementarySection';
import PropertiesForm from '@/modules/ProjectModule/modules/UnitModule/components/Form/PropertiesForm';
import BasicForm from '@/modules/ProjectModule/modules/UnitModule/components/Form/BasicForm';
import BuildingForm from '@/modules/ProjectModule/modules/UnitModule/components/Form/BuildingForm';
import OtherForm from '@/modules/ProjectModule/modules/UnitModule/components/Form/OtherForm';

export default {
    name:       'DetailContainer',
    components: {OtherForm, BuildingForm, BasicForm, PropertiesForm, ElementarySection},
    methods:    {
        onSubmit(data) {
            this.$store.dispatch('projects/project/units/unit/updateUnit', data)
                .then(() => this.$dmv.notifySuccess('Upraveno'))
                .catch((message) => this.$dmv.notifyError(message));
        }
    }
}
</script>
